const calculateSelectedGames = allGames => {
  if (!allGames) {
    return null;
  }
  const selectedGames = allGames.filter(g => g.checked === true);
  return selectedGames.length;
};

export default calculateSelectedGames;
